import { IAttendance } from "@grassrootly/api/entities";
import { UpdatePlayerGameStatsPayload } from "@grassrootly/api/gateways";
import server from "@grassrootly/api/providers/supabase-provider/Server";
import withErrorCheck from "../CheckError";

export const UpdatePlayerGameStats = async (params: UpdatePlayerGameStatsPayload): Promise<IAttendance> => {
  const data = withErrorCheck(
    await server.from("GameAttendances").select("*").eq("game_id", params.gameId).eq("player_id", params.playerId)
  );
  let attendance = data?.length ? data[0] : null;
  if (!attendance) {
    throw new Error("This player does not attending this game");
  }
  const updateData: any = { 
    ...attendance, 
    goals_scored: params.goals, 
    assists_made: params.assists
  };
  
  if (params.ownGoals !== undefined) {
    updateData.own_goals = params.ownGoals;
  }
  
  if (params.errors !== undefined) {
    updateData.errors_leading_to_a_goal = params.errors;
  }
  
  if (params.yellowCards !== undefined) {
    updateData.yellow_cards = params.yellowCards;
  }
  
  if (params.redCards !== undefined) {
    updateData.red_cards = params.redCards;
  }
  
  if (params.saves !== undefined) {
    updateData.saves = params.saves;
  }
  
  return withErrorCheck(
    await server
      .from("GameAttendances")
      .update(updateData)
      .eq("id", attendance.id)
      .select()
  )[0];
};
